import React from "react";
import CapabilitySummary from "./capability-summary";
import { CapabilityListSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type ICapabilityListProps = Slice<
  SharedSliceType.capability_list,
  CapabilityListSliceFragment["primary"]
> & { type: SharedSliceType.capability_list };

const CapabilityList = ({
  slice,
  context,
}: SliceComponentProps<ICapabilityListProps, IPageContext>) => {
  const title = slice.primary?.title1;
  const result: Array<JSX.Element> = [];

  // If CapabilityListSliceFragment["items"] is added to the following union type
  // TS would return the following non compatible call signature error:
  //   `Each member of the union type has signatures, but none of those signatures are compatible with each other`
  // This seems to be an open issue within TS that is described in the this issue: https://github.com/microsoft/TypeScript/issues/33591
  const capabilities: CapabilityListSliceFragment["items"] | undefined | null =
    slice.items;

  if (capabilities) {
    capabilities.some((capabilityField, index) => {
      capabilityField?.capability?.document &&
        result.push(
          <CapabilitySummary
            key={index}
            capability={capabilityField.capability}
          />
        );
      return result.length > 3;
    });
  }

  return (
    <section className="slice-section">
      <div className="container">
        {title && <h3>{title}</h3>}
        {result}
      </div>
    </section>
  );
};

export default CapabilityList;
